import { useState, useEffect } from "react";
import Table from "../Table/Table";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { Bounce, toast } from "react-toastify";
import PopUp from "../PopUp";

const Sedi = () => {
  const [loading, setLoading] = useState(false);
  const [sedi, setSedi] = useState([]);
  const navigate = useNavigate();
  const [perPage] = useState(20);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [showPopUp, setShowPopUp] = useState(false);
  const [selectedSedeId, setSelectedSedeId] = useState(null);

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    if (userRole !== "ADMIN") {
      alert("Accedi come amministratore per visualizzare le sedi!");

      navigate("/login");
      localStorage.clear();
    } else {
      fetchSedi();
    }
  }, [navigate]);

  const fetchSedi = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/sedi`);
      if (response.status === 200) {
        setSedi(response.data);
        setTotalRows(response.data.length);
      } else {
        toast.error("Qualcosa è andato storto!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleRowClick = (sede) => {
    navigate(`/sede/${sede.idSede}`);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginatedSedi = sedi.slice(
    (currentPage - 1) * perPage,
    currentPage * perPage
  );

  const columns = [
    {
      field: "indirizzoSede",
      header: "Indirizzo Sede",
      size: 600,
      enableSorting: true,
      enableColumnFilter: true,
    },
    {
      header: "Azioni",
      size: 150,
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <button
          className="outside-delete-btn"
          onClick={(e) => {
            e.stopPropagation();
            setSelectedSedeId(row.original.idSede);
            setShowPopUp(true);
          }}
        >
          <i className="fa-solid fa-trash"></i> Elimina
        </button>
      ),
    },
  ];

  const handleDelete = async () => {
    if (!selectedSedeId) {
      return;
    }
    try {
      const response = await api.delete(`/sedi/${selectedSedeId}`);
      if (response.status === 204) {
        toast.success("Sede aggiunta con successo!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        fetchSedi();
      } else {
        toast.error("Qualcosa è andato storto!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      console.error(error);

      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setShowPopUp(false);
      setSelectedSedeId(null);
    }
  };

  return (
    <div className="content-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <PopUp
        open={showPopUp}
        setOpen={setShowPopUp}
        header="Conferma Eliminazione"
        content="Sei sicuro di voler rimuovere questa sede?"
        deleteFunction={handleDelete}
      />

      <div className="page-header">
        <div className="page-title">Sedi</div>
        <div className="controls">
          <div className="add-btn">
            <button onClick={() => navigate("/aggiungi-sede")}>
              + Nuova sede
            </button>
          </div>
        </div>
      </div>

      <div className="page-content sedi">
        <Table
          columns={columns}
          data={paginatedSedi}
          onRowClick={handleRowClick}
          onPageChange={handlePageChange}
          totalRows={totalRows}
          perPage={perPage}
          currentPage={currentPage}
        />
      </div>
    </div>
  );
};

export default Sedi;
